import axios from "./axios";
import { addToCart } from "../action";
import { persistor } from "../store";
import { trackAddToCart } from "./analyticsConsent";

function whenCartReady() {
    if (persistor.getState().bootstrapped) return Promise.resolve();
    return new Promise((resolve) => {
        const unsubscribe = persistor.subscribe(() => {
            if (!persistor.getState().bootstrapped) return;
            unsubscribe();
            resolve();
        });
    });
}

function imageUrl(path) {
    if (!path) return "";
    const value = String(path).trim();
    if (!value) return "";
    if (/^https?:\/\//i.test(value)) return value;
    const base = String(process.env.REACT_APP_IMAGE_URL || "").trim().replace(/\/+$/, "");
    return `${base}${value.startsWith("/") ? value : `/${value}`}`;
}

function cartItemsFromState(store) {
    const raw = store.getState()?.cart?.cartItems;
    return Array.isArray(raw) ? raw : [];
}

function fail(message) {
    const result = { ok: false, message };
    window.dispatchEvent(new CustomEvent("albi-cart-result", { detail: result }));
    return result;
}

async function addNow(store, input) {
    const sku = String(input?.sku || input?.skuId || "").trim();
    const location = input?.location ? String(input.location).trim() : "";
    const quantity = Number(input?.quantity ?? input?.qty ?? 1);

    if (!sku) return fail("SKU mungon.");
    if (!location) return fail("Dyqani (location) mungon.");
    if (!Number.isInteger(quantity) || quantity < 1) {
        return fail("Sasia nuk është e vlefshme.");
    }

    await whenCartReady();

    let data;
    try {
        const res = await axios.post("/productbysku", { skuId: sku, location });
        data = res?.data;
    } catch (error) {
        return fail("Produkti nuk u shtua. Provoni përsëri.");
    }

    if (!data?.found || !data?.product) {
        return fail(data?.message || "Produkti nuk u gjet.");
    }

    const product = data.product;
    if (product.isActive === false) return fail("Ky variant nuk është aktiv.");

    const stock = Number(product.stock) || 0;
    if (stock < 1) return fail("Produkti nuk është në stok.");

    const cartItems = cartItemsFromState(store);
    const existingIndex = cartItems.findIndex(
        (item) =>
            item.item_code === product.skuId &&
            item.size === product.size &&
            String(item.location || "") === String(product.location || "")
    );

    let nextCart = [...cartItems];
    let lineQuantity = quantity;

    if (existingIndex >= 0) {
        const existing = nextCart[existingIndex];
        lineQuantity = Number(existing.quantity) + quantity;
        if (lineQuantity > stock) {
            return fail(`Stoku i disponueshëm është ${stock}. Në shportë keni ${existing.quantity}.`);
        }
        nextCart[existingIndex] = { ...existing, quantity: lineQuantity, stockQty: stock };
    } else {
        if (quantity > stock) {
            return fail(`Stoku i disponueshëm është ${stock}.`);
        }
        nextCart.push({
            _id: product.externalId,
            brandEmail: product.storeEmail || "",
            email: product.email || "",
            name: product.name,
            item_code: product.skuId,
            description: product.description,
            dimensions: product.dimensions,
            vendor: product.vendor || product.storeName || product.brand || "",
            composition: product.composition,
            collectionn: product.collectionn,
            images: [imageUrl(product.image)],
            catId: product.categories?.[0] || "",
            vendorId: product.vendorId,
            brand: product.brand,
            changeFlag: product.changeFlag,
            color: product.color,
            countryOfOrigin: product.attributes?.["Country of origin"] || "",
            itemCategory: product.categories?.[0] || "",
            itemNo: "",
            itemSubCategory: "",
            published: "1",
            regular_price: product.regularPrice || 0,
            sale_price: product.salePrice || 0,
            season: product.attributes?.Season || "",
            gender: product.attributes?.Gender || "",
            size: product.size,
            startDate: product.startDate,
            stockQty: stock,
            quantity,
            location: product.location,
            storeName: product.storeName || "",
            prodId: product.prodId,
            uniqueId: Math.floor(1000000000 + Math.random() * 9000000000),
            attributes: product.attributes,
        });
    }

    await store.dispatch(addToCart(nextCart));

    try {
        trackAddToCart({
            productId: product.externalId,
            sku: product.skuId,
            name: product.name,
            category: product.categories?.[0],
            price: product.salePrice || product.regularPrice || 0,
            quantity,
        });
    } catch (error) {
        // Tracking must not block the cart update.
    }

    const result = {
        ok: true,
        message: "Produkti u shtua në shportë.",
        sku: product.skuId,
        name: product.name,
        size: product.size,
        quantity: lineQuantity,
        cartCount: nextCart.reduce((sum, item) => sum + Number(item.quantity || 0), 0),
    };
    window.dispatchEvent(new CustomEvent("albi-cart-result", { detail: result }));
    return result;
}

export function installAlbiCart(store) {
    if (window.AlbiCart?.add) return;

    let queue = Promise.resolve();
    const add = (input) => {
        const run = queue.then(() => addNow(store, input || {}));
        queue = run.then(() => undefined, () => undefined);
        return run;
    };

    window.AlbiCart = { add };
}
